import {Shape} from './index.js';

export class Curve extends Shape {
	constructor({ points = [], stroke = [1, 'black'] }) {
		super({ x: 0, y: 0, stroke });
		this.points = points;
	}

	draw(context) {
		if (this.points.length < 2) return;
		context.save();
		context.beginPath();
		context.moveTo(this.points[0].x, this.points[0].y);
		for (let i = 1; i < this.points.length - 1; i++) {
			let xc = (this.points[i].x + this.points[i + 1].x) / 2;
			let yc = (this.points[i].y + this.points[i + 1].y) / 2;
			context.quadraticCurveTo(this.points[i].x, this.points[i].y, xc, yc);
		}
		context.strokeStyle = this.stroke.top.color;
		context.lineWidth = this.stroke.top.size;
		context.stroke();
		this.beforeRestore(context)
		context.restore();
	}
}
